jQuery(document).ready(function() {
    jQuery('.mini-banner-content').click(function(){
      //window.location = jQuery('.'+jQuery(this).attr('id')).attr('href');
      //jQuery('.'+jQuery(this).attr('id'))[0].click();
      if (jQuery('.'+jQuery(this).attr('id')).length) {
          jQuery('.'+jQuery(this).attr('id'))[0].click();
      } 
    });
  
    jQuery(".mini-banner-content .banner-detail a").click(function(e) {
      e.preventDefault();
      var target = jQuery(this).attr('href');
      jQuery('html, body').animate({
         scrollTop: (jQuery(target).offset().top)
      }, 2000);
    });
});